import bootstrap from './utils/bootstrap/bootstrap'
import config from './config'
import { adRpcServerFactory } from './services/adRpcServer/adRpcServer'

bootstrap(() => {
  adRpcServerFactory(
    window,
    config.AD_RPC_NAMESPACE,
    window.placementOptions,
    window.impressionTrackerParams,
    window.samplingDecision
  ).listen()
})
